if(!customElements.get("accept-terms")) {
  customElements.define("accept-terms", class AcceptTerms extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }
  });
}